export default {
  Name: "",
  Id: 0,
  IsEnabled: false,
  IsNull: false
};
